import { useEffect, useState } from "react";
import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { Table, type TableProps } from "antd";
import StatusVisit from "../../components/StatusVisit";
import ButtonIcon from "../../components/ButtonIcon";
import ConfirmModal from "../../components/modal/ConfirmModal";
import { Link } from "react-router";
import BaseCard from "../../components/card/BaseCard";
import { Icon } from "@iconify/react";
import BaseTable from "../../components/BaseTable";
import { $api, type components } from "../../helper";
import ButtonLinkIcon from "../../components/ButtonLinkIcon";
import { useNotify } from "../../helper/notify";
import FilterSearch from "../../components/filter/FilterSearch";
import ButtonIconSvg from "../../components/ButtonIconSvg";
import Trash from "../../components/svg/Trash";
import ButtonLinkIconSvg from "../../components/ButtonLinkIconSvg";
import PenSquare from "../../components/svg/PenSquare";
import FilterStatus from "../../components/FilterStatus";
import { statusMock } from "../../helper/mock";

export default function Faq() {
  const [isOpen, setIsOpen] = useState(false);
  const notify = useNotify();
  const [id, setId] = useState({
    u_id: "",
    title: "",
  });
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/faq/",
  );
  const { mutate, isPending } = $api.useMutation("delete", "/site-api/v1/faq/");

  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("سوالات متداول");
  }, []);

  const columns: TableProps<components["schemas"]["SiteFaqItem"]>["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record?.title
          ?.toLowerCase()
          ?.includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
    },
    {
      title: "دسته بندی",
      dataIndex: "category",
      key: "category",
      filters: data?.data?.map((e) => ({
        text: e.category,
        value: e.category,
      })),
      onFilter: (value, record) =>
        record.category.indexOf(value as string) === 0,
    },
    {
      title: "پر تکرار است",
      dataIndex: "repeat",
      key: "repeat",
      filters: data?.data?.map((e) => ({
        text: e.is_repeat ? "پرتکرار است" : "پر تکرار نیست",
        value: e.is_repeat,
      })),
      onFilter: (value, record) =>
        record.is_repeat.toString().indexOf(value as string) === 0,
      render: (_, record) => (
        <Icon
          className={`text-3xl ${record.is_repeat ? "text-success-500" : "text-error-500"}`}
          icon={
            record.is_repeat
              ? "solar:check-circle-bold-duotone"
              : "solar:close-circle-bold-duotone"
          }
        />
      ),
    },
    {
      title: "نمایش در سایت",
      key: "show",
      dataIndex: "show",
      filters: statusMock,
      onFilter: (value, record) =>
        record.status.toString().indexOf(value as string) === 0,
      render: (_, record) => <StatusVisit status={record.status} />,
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          {/* <ButtonLinkIcon
            to={{
              pathname: "/add-faq",
              search: "?u_id=" + record.u_id,
            }}
            icon="solar:pen-new-square-linear"
            className="text-primary-500!"
          /> */}
          <ButtonLinkIconSvg
            icon={<PenSquare />}
            to={{
              pathname: "/add-faq",
              search: "?u_id=" + record.u_id,
            }}
            className="text-primary-500!"
          />
          {/* <ButtonIcon
            icon="solar:trash-bin-trash-linear"
            className="text-error-500!"
            onClick={() => {
              setId({ title: record.title, u_id: record.u_id });
              setIsOpen(true);
            }}
          /> */}
          <ButtonIconSvg
            icon={<Trash />}
            className="text-error-500!"
            onClick={() => {
              setId({ title: record.title, u_id: record.u_id });
              setIsOpen(true);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <ConfirmModal
        pending={isPending}
        title="حذف از سوالات متداول ؟"
        description="حذف این سوال باعث عدم نمایش آن در بخش‌های مرتبط می‌شود."
        action={() =>
          mutate(
            { params: { query: { faq_u_id: id.u_id } } },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setIsOpen(false);
                setId({ title: "", u_id: "" });
                refetch();
              },
            },
          )
        }
        open={isOpen}
        onClose={() => {
          setId({ title: "", u_id: "" });
          setIsOpen(false);
        }}
      />
      <div className="w-full flex justify-end sm:flex-row sm:gap-0 gap-4 flex-col sm:items-center items-start">
        <Link to={"/add-faq"} className="button-style">
          ایجاد سوال
        </Link>
      </div>

      <BaseCard props={{ className: "flex-1 w-full! flex-col flex gap-6" }}>
        <BaseTable props={{ className: "w-full! grid! grid-cols-1!" }}>
          <Table<components["schemas"]["SiteFaqItem"]>
            loading={isLoading}
            className="col-span-1!"
            scroll={{ x: "max-content" }}
            columns={columns}
            dataSource={data?.data}
          />
        </BaseTable>
      </BaseCard>
    </div>
  );
}
